<template>
  <div class="noScroller">
    <v-app id="inspire2">
      <NewToolbar></NewToolbar>
      <div v-if="$store.getters.getShowButton">
        <v-btn
          v-if="activeComponent == 'OperationalScreen_Main'"
          fab
          small
          fixed
          top
          left
          color="secondary"
          @click="toggleLeftPane"
          class="back_top_floating_button"
        >
          <v-icon small v-if="configScreenActive">fast_rewind</v-icon>
          <v-icon small v-else>fast_forward</v-icon>
        </v-btn>
        <v-btn
          v-else
          fab
          small
          fixed
          top
          left
          color="secondary"
          @click="goBack"
          class="back_top_floating_button"
        >
          <v-icon small>arrow_back_ios</v-icon>
        </v-btn>
      </div>

      <v-navigation-drawer
        v-if="configScreenActive"
        class="scroll"
        width="320"
        persistent
        :mini-variant="miniVariant"
        :clipped="toolabar.clippedLeft && !nav.right || toolabar.clippedRight"
        v-model="drawer"
        enable-resize-watcher
        app
        :right="nav.right"
      >
        <v-list class="tree_bar primary"></v-list>
        <div>
          <v-flex class="ml-2 mr-2 back_top_floating_button_spacing">
            <component
              :is="sideComponentName"
              :properties="sideComponentProfile"
              :options="options"
            ></component>
          </v-flex>
        </div>
      </v-navigation-drawer>

      <v-content id="jonny_area" class="pt-2 pb-2" :style="backgroundStyle">
        <!-- <v-layout column> -->
        <v-flex>
          <component
            :is="mainContentComponent"
            :properties="mainContentProperties"
            :options="options"
          ></component>
        </v-flex>
        <!-- </v-layout> -->
      </v-content>
    </v-app>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import OperationalScreen_MapQuadrant from "@/components/OperationalScreen/OperationalScreen_MapQuadrant";
import Orders_Main from "@/components/Orders/Orders_Main";
import Account_Main from "@/components/Account/Account_Main";
import appConfig from "../../config/app_config";
import Events_main from "@/components/Events/Events_main";
import Financial_Main from "@/components/Financial/Financial_Main";
import * as dssRequest from "@/api/dssRequest";
import QuadrantObject from "@/objects/QuadrantObject";
import BaseObject from "@/objects/BaseObject";
// import * as parser from "@/api/Parser";
import Locations_Main from "@/components/Locations_Main";
import NavigationOverview from "@/components/NavigationOverview";
import AddLocation from "@/components/AddLocation";
import BaseAspect from "@/aspects/BaseAspect";
import LocationObject from "@/objects/LocationObject";
import BatchGroupObject from "@/objects/BatchGroupObject.js";
import NewToolbar from "@/components/NewToolbar";
import EventView_Main from "@/components/EventView_Main";
import EventView_Overview from "@/components/EventView_Overview";
import { ui_helpers } from "../shared/ui_helpers";
import BaseComponent from "./base/BaseComponent.vue";
import OperationalScreen_Main from "@/components/OperationalScreen/OperationalScreen_Main";
import EventCreation from "@/components/EventCreation";
import EventWizard_Main from "@/components/EventWizard_Main";
import Events_Batchgroups from "@/components/Events/Events_Batchgroups";
import Events_Languages from "@/components/Events/Events_Languages";
import Events_Editing from "@/components/Events/Events_Editing";
import Events_main_old from "@/components/Events/Events_main_old";
import Statistics_Main from "@/components/Statistics/Statistics_Main";

export default {
  name: "DashBoard",
  extends: BaseComponent,
  mixins: [ui_helpers],
  components: {
    Orders_Main,
    Locations_Main,
    NavigationOverview,
    AddLocation,
    NewToolbar,
    OperationalScreen_MapQuadrant,
    Account_Main,
    EventView_Main,
    EventView_Overview,
    OperationalScreen_Main,
    EventCreation,
    EventWizard_Main,
    Events_main,
    Events_Batchgroups,
    Events_Languages,
    Events_Editing,
    Financial_Main,
    Events_main_old,
    Statistics_Main
  },
  props: {
    properties: Object
  },
  data() {
    return {
      activeComponent: "",
      mainContentComponent: "OperationalScreen_Main", //Starting the user at dashboard,
      mainContentProperties: {},
      sideComponentProfile: {
        title: this.$translate("LOCATION_OVERVIEW")
      },
      sideComponentName: "",
      communicationList: ["Send notification screen", "Communication Centre"],
      ConfigList: ["Home", "Logout"],
      disableOnEnlarge: false,
      dialog: false,
      typeQuadrant: ["Map", "Event", "Incident"],
      options: {},
      dragover: false,
      el: {},
      columns: 3,
      rows: 2,
      windowWidth: 100,
      windowHeight: 100,
      settings: {},
      sideOpen: true,
      opScreenActive: true,
      configScreenActive: true,
      commScreenAcitve: false,
      baseProfile: {
        tag: "",
        default: false,
        style: {
          height: ""
        }
      },
      mapVar: new Map(),
      mapProperty: "",
      drawer: true,
      clipped: false,
      toolabar: {
        clippedLeft: false,
        clippedRight: false
      },
      nav: {
        right: false
      },
      miniVariant: false,
      loading: false,
      componentId: 0,
      cleanUpChild: false
    };
  },
  watch: {
    getQuadrantWidth() {
      // retrieving the quadrant width
      return this.windowWidth / this.columns;
    },
    getQuadrantHeight() {
      // retrieving the quadrant height
      return this.windowHeight / this.rows;
    },
    filterTags: {
      handler(data) {
        this.getAllLocations();
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      filterTags: "getFilterTags",
      _filterName: "getFilterName",
      sortLocationOrder: "getSortLocationOrder",
      _getFiltersLocation: "getFiltersLocation",
      currentComponent: "getCurrentComponent",
      _filterEventsName: "getEventFilterName",
    })
  },
  created() {
    this.$store.commit("setDashboardStatus", 1);
    // code for map object and linking to the area as well
    this.mapVar.set(appConfig.dss.destinationObjectId, [
      ["TO_STATE_UPDATE", ["IncidentAspectData", "UserAspectData"]],
      ["incidentAspectUpdate", ["IncidentAspectData"]],
      ["userAspectUpdate", ["UserAspectData"]],
      ["routeAspectUpdate", ["RouteAspectData"]],
      ["CapacityUpdate", ["CapacityData"]],
      ["userLocationUpdate", ["userLocationData"]]

    ]);

    const _profile = JSON.parse(JSON.stringify(this.baseProfile));
    // _profile.connect = false;
    _profile.style.height = "big";
    _profile.landing = true;
    _profile.relink = true;
    this.mapProperty = this.makeBox(
      "OperationalScreen_MapQuadrant",
      _profile,
      this.sigObjMap2,
      "",
      0,
      0,
      true
    );

    const _profile2 = JSON.parse(JSON.stringify(this.baseProfile));

    _profile2.relink = true;
    _profile2.style.height = "small";

    window.EventBus.listen("storeSettings", this.storeConfiguration);
    window.EventBus.listen("creationDialog", data => (this.drawer = data));
    window.EventBus.listen("setMainContentComponent", this.setMainComponent);
    window.EventBus.listen("setSideComponentName", this.setSideComponent);
    window.EventBus.listen("toggleLeftPane", this.toggleLeftPane);

    window.EventBus.listen("getLocations", this.getAllLocations);
    window.EventBus.listen(
      "getEventsBasedOnUserLevel",
      this.getEventsBasedOnUserLevel
    );
    if (!_.isEmpty(this.$attrs) && undefined !== this.$attrs.page) {
      //receiving components from the attrs
      this.setMainComponent(this.$attrs.mainComponent);
      this.setSideComponent(this.$attrs.sideComponent);
    } else {
      this.getAllLocations();
    }

    this.getEventsBasedOnUserLevel();
  },
  mounted() {
    this.$store.commit("setFilterName", "");
    this.$store.commit("setEventFilterName", "");
    window.EventBus.fire("getTagDefUserGroupsAndSystemRoles");
    // this.showComponents(this.$store.getters.getSelectedItem.link);
  },
  beforeDestroy() {
    window.EventBus.removeListener("objectList", this.allObjectList);
    window.EventBus.removeListener("partOfDialog", this.showPartOfDialog);
    window.EventBus.removeListener("getLocations", this.getAllLocations);
    window.EventBus.removeListener("toggleLeftPane", this.toggleLeftPane);
    window.EventBus.removeListener(
      "getEventsBasedOnUserLevel",
      this.getEventsBasedOnUserLevel
    );
  },
  methods: {
    getEventsBasedOnUserLevel(filters = null) {
      if(!!!this.$store.getters.getSelectedItem){
        this.$store.commit(
          "setSelectedItem",
          {
            link:
              { main: "OperationalScreen_Main",
                side: ""
              },
            selected: true,
            title: "Dashboard"
          })
      }
      let payload = {
        FunctionId: "EventFunctionLibrary::getEventsBasedOnUserLevel",
        UserLevel: this.$store.getters["auth/userLevel"],
        PartnerId: this.$store.getters["auth/partnerId"],
        Filters: {
          LocationId: "",
          Tags: {},
          Type: {},
          Name: this._filterEventsName
        }
      };

      let doNotSaveOnType = false;
      if (filters != null) {
        if (!_.isEmpty(filters.Tags)) {
          payload.Filters.Tags = filters.Tags;
        }
        if (!_.isEmpty(filters.Type)) {
          doNotSaveOnType = true;
          payload.Filters.Type = filters.Type;
        }
        if (!_.isEmpty(filters.LocationId)) {
          payload.Filters.LocationId = filters.LocationId;
        }
      }
      if (this.$store.getters.getEventFilterName !== '') {
        doNotSaveOnType = true;
      }
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call 'getEventsBasedOnUserLevel' on - Dashboard.vue - was successful",
            response
          );
          if (!response.data.hasOwnProperty('Events')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GEBOU_001');
            return;
          }
          let events = BaseObject._toLowerCaseInitialProperty(
            BaseObject._createArrayWithObjects(response.data.Events)
          );
          events.forEach(e => {
            e.selected = false;
          });

          if (!doNotSaveOnType) {
            this.$store.commit("setRouteEvents", events);
          }
          this.$store.commit("setEvents", events);
        },
        error => {
          console.log(
            "The generic call 'getEventsBasedOnUserLevel' on - Dashboard.vue - was not successful",
            error
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GEBOU_001');
        },
        "communicateWithDBLibrary",
        this.currentAccountId,
        payload,
        600000,
        false
      );
    },
    getAllLocations(data = null) {
      let tags = {};
      this.filterTags.forEach(e => {
        let j = e.entries.filter(s => s.status).map(i => i.k);
        tags[e.title] = {};
        j.forEach(t => {
          tags[e.title][t] = t;
        });
      });
      const payload = {
        FunctionId: "LocationFunctionLibrary::getLocationsV2",
        Tags: tags,
        PartnerId: this.$store.getters['auth/partnerId'],
        Name: this._filterName,
        OrderBy: this.sortLocationOrder ? "Name ASC" : "Name DESC",
        Containers: {}
      };
      if (data !== null && data.hasOwnProperty("filters")) {
        if (data.filters.hasOwnProperty("partOf")) {
          let loc = data.filters.partOf;
          payload.Containers[loc.locationId] = loc.locationId;
        }
      } else if (
        !_.isEmpty(this._getFiltersLocation) &&
        !_.isEmpty(this._getFiltersLocation.filters)
      ) {
        payload.Containers[
          this._getFiltersLocation.filters.partOf.locationId
          ] = this._getFiltersLocation.filters.partOf.locationId;
      }
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call 'getLocationsV2' on - Dashboard.vue - was successful",
            response
          );
          if (!response.data.hasOwnProperty('Locations')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GL_001');
            return;
          }
          let locations = LocationObject._createArrayWithObjects(
            response.data.Locations
          );
          this.$store.commit("locationsModule/setLocations", locations);
          window.EventBus.fire("functionStatus", {
            f: "getAllLocations",
            status: "ok",
            error: false
          });
        },
        error => {
          console.log(
            "The generic call 'getLocationsV2' on - Dashboard.vue - was not successful",
            error
          );
          window.EventBus.fire("functionStatus", {
            f: "getAllLocations",
            status: "ok",
            error: true
          });
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GL_001');
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload,
        600000,
        false,
      );
    },
    goBack() {
      if (this.currentComponent == "Locations_Main") {
        this.showComponents({
          main: "Locations_Main",
          side: "NavigationOverview",
          mainParams: null,
          sideParam: null
        });
      } else if (this.currentComponent == "OperationalScreen_Main") {
        this.showComponents({
          main: "OperationalScreen_Main",
          side: "",
          mainParams: null,
          sideparam: null
        });
      } else if (this.currentComponent == "Events_main") {
        this.showComponents({
          main: "Events_main",
          side: "EventView_Overview",
          mainParams: null,
          sideparam: null
        });
      } else if (this.currentComponent == "Account_Main") {
        this.showComponents({
          main: "Account_Main",
          side: "",
          mainParams: null,
          sideparam: null
        });
      } else {
        this.$router.go(-1);
      }
    },
    toggleLeftPane(data) {
      this.configScreenActive = !this.configScreenActive;
    },
    showPartOfDialog(data) {
      this.partOfDialog = true;
      this.partOfArray = data;
    },
    setSideComponent(data) {
      console.log("data in setSideComponent: ", data);

      delete this.sideComponentProfile.location;
      this.sideComponentProfile.type = "add";
      if (data.params !== null && data.params.type === "edit") {
        // show in edit mode
        this.sideComponentProfile.type = "edit";
        this.sideComponentProfile.location = data.params.location;
      }

      /**
       * IMPORTANT
       * this.$set(object, subproperty, value)
       * allows the object to be reactive in its nested property
       * instead of directly set object.subproperty = new value
       */
      this.$set(this.sideComponentProfile, "params", data.params);
      this.sideComponentName = data.component;
      if (this.sideComponentName == "") this.configScreenActive = false;
      else this.configScreenActive = true;
    },
    setMainComponent(data) {
      console.log("data in setMainComponent: ", data);

      if (data.component === "OperationalScreen_MapQuadrant") {
        this.mainContentProperties = this.mapProperty;
        this.mainContentProperties.showToolbar = false;
        this.mainContentProperties.fullSize = true;
        this.mainContentProperties.profile.connect = false;
      } else if (data.component === "Locations_Main") {
        this.getAllLocations();
      }

      /**
       * IMPORTANT
       * this.$set(object, subproperty, value)
       * allows the object to be reactive in its nested property
       * instead of directly set object.subproperty = new value
       */
      this.$set(this.mainContentProperties, "params", data.params);
      // this.mainContentProperties.params = data.params;
      this.mainContentComponent = data.component;
      this.activeComponent = data.component;
    },
    toggleSide() {
      this.sideOpen = !this.sideOpen;
      this.drawer = !this.drawer;
    },
    checkIfCommActive() {
      if (this.commScreenAcitve == true) {
        return "currentlyActive";
      }
      if (this.commScreenAcitve == false) {
        return "";
      }
    },
    showAddDialog() {
      this.dialog = !this.dialog;
    },
    onEvent(container) {
      const data = container.data;
    },
    onLayoutUpdate(evt) {
      this.layout = evt.layout;
    },
    makeBox(
      type = "OperationalScreen_MapQuadrant",
      profile = this.baseProfile,
      signalMap = new Map(),
      tag = "",
      _x = null,
      _y = null,
      paramFlag = false
    ) {
      _x = _x == null ? this.componentId % this.columns : _x;
      _y = _y == null ? Math.floor(this.componentId / this.columns) : _y;

      let id = profile.default == true ? 0 : this.componentId++;
      if (paramFlag === false) {
        profile.style.height = this.windowHeight / this.rows + "px;";
        profile.style.width = this.windowWidth / this.columns + "px;";
      } else {
        id = QuadrantObject._createPinCode();
      }
      let _profile = JSON.parse(JSON.stringify(profile));

      let container = QuadrantObject._objectDefinition(
        id,
        type,
        profile.default
      );

      container.tag = tag;
      container.profile = _profile;
      container.signalObjectMap = new Map(signalMap);
      container.position.x = _x;
      container.position.y = _y;
      container.showToolbar = true;
      container.showBackButton = true;
      return container;
    }
  }
};
</script>
<style lang="scss" scoped="">
.main_area_dashboard {
  /*    background: #f2f2f2;*/
  height: 85vh;
  overflow-y: hidden;
  overflow-x: hidden;
}
.drop_zone {
  height: 200px;
  border: 1px dashed #000;
  &.ready {
    box-shadow: inset 0 0 0 20px rgba(0, 0, 0, 0);
    background: rgba(255, 0, 0, 0.26);
  }
}

.menu_button {
  margin-right: 15px;
}

.divideHalf {
  height: 50%;
}

.notificationList {
  background-color: #eff0ee;
  max-height: 250px;
  overflow-y: scroll;
}

.auto_height {
  // min-height: 300px;
  height: auto;
}
.scroll {
  overflow: hidden !important;
  margin-top: 1em;
}
.activ_icon {
  margin-left: 7px;
  margin-top: 3px;
}
.show_details {
  display: block !important;
}
.hide_details {
  display: none !important;
}
.scrollList {
  height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.noScroller {
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
